import React, { createContext, useContext, useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { collection, getDoc, doc, query, or, where, onSnapshot } from 'firebase/firestore';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [connectedUsers, setConnectedUsers] = useState(() => {
    const cached = localStorage.getItem('connectedUsers');
    return cached ? JSON.parse(cached) : [];
  });

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;

    const connectionsRef = collection(db, 'connections');
    const q = query(
      connectionsRef,
      or(
        where('userId', '==', user.uid),
        where('partnerId', '==', user.uid)
      )
    );

    const unsubscribe = onSnapshot(q, async (querySnapshot) => {
      const users = await Promise.all(
        querySnapshot.docs.map(async (docSnap) => {
          const connectionData = docSnap.data();
          const partnerId = connectionData.userId === user.uid
            ? connectionData.partnerId
            : connectionData.userId;

          const partnerDoc = await getDoc(doc(db, 'users', partnerId));
          if (!partnerDoc.exists()) return null;

          return {
            id: partnerId,
            ...partnerDoc.data(),
            lastMessageTime: connectionData.lastMessageTime?.toDate?.() || null,
            lastMessage: connectionData.lastMessage || '',
          };
        })
      );

      const sortedUsers = users.filter(Boolean).sort(
        (a, b) => (b.lastMessageTime?.getTime() || 0) - (a.lastMessageTime?.getTime() || 0)
      );

      setConnectedUsers(sortedUsers);
      localStorage.setItem('connectedUsers', JSON.stringify(sortedUsers));
    });

    return () => unsubscribe();
  }, []);

  return (
    <UserContext.Provider value={{ connectedUsers, setConnectedUsers }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);
